module.exports = __webpack_public_path__ + "static/media/8.7c19dc6e.jpg";